"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports.default = void 0;
var _react = require("react");
var _css = require("@emotion/css");
var _useStylesUtils = require("../../hooks/useStylesUtils");
var _CetComponentsProvider = require("../../providers/CetComponentsProvider");
const useStyles = props => {
  const {
    themeColors
  } = (0, _react.useContext)(_CetComponentsProvider.CetComponentsContext);
  const {
    pxToRem
  } = (0, _useStylesUtils.useStylesUtils)();
  const ccProgressStyle = (0, _react.useMemo)(() => {
    const {
      percentage
    } = props;
    const ccProgress = (0, _css.css)({
      overflow: 'hidden',
      position: 'relative',
      display: 'flex',
      flexWrap: 'nowrap',
      justifyContent: 'flex-start',
      alignItems: 'stretch',
      boxSizing: 'content-box',
      height: pxToRem(6),
      borderTop: '1px solid transparent',
      borderBottom: '1px solid transparent',
      borderRadius: pxToRem(6),
      margin: `${pxToRem(1)} 0`,
      background: themeColors?.primary.light
    });
    const ccProgressPercentage = (0, _css.css)({
      position: 'absolute',
      background: themeColors?.primary.main,
      height: pxToRem(6),
      borderRadius: pxToRem(6),
      left: 0,
      width: `${percentage}%`
    });
    return {
      ccProgress,
      ccProgressPercentage
    };
  }, [props, pxToRem, themeColors?.primary.light, themeColors?.primary.main]);
  return {
    'cc-Progress': ccProgressStyle.ccProgress,
    'cc-Progress__percentage': ccProgressStyle.ccProgressPercentage
  };
};
exports.useStyles = useStyles;
var _default = exports.default = useStyles;